var _defs, _metadata;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    viewBox: "0 0 264.58333 264.58334",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-32.41665)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      fill: "#2c5aa0",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.32291663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "path815",
    cx: 133.20712,
    cy: 165.66373,
    r: 113.37573
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#000000",
      stroke: "none",
      strokeWidth: "0.99999994px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 641.49219 193.51953 L 550.12891 233.49609 L 492.14648 273.09375 L 456.79102 404.61523 L 365.42773 506.00781 L 474.96484 615.54492 L 406.64648 826.16406 L 512.28711 931.80469 A 428.5067 428.5067 0 0 0 931.9668 503.61133 A 428.5067 428.5067 0 0 0 931.24609 483.27344 L 641.49219 193.51953 z ",
    transform: "matrix(0.26458333,0,0,0.26458333,0,32.41665)",
    id: "path828"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "f",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "299.61590576px",
      lineHeight: 1.25,
      fontFamily: "'8BIT WONDER'",
      InkscapeFontSpecification: "'8BIT WONDER'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.30524549
    },
    id: "text819",
    transform: "matrix(0.86678861,0,0,0.86678861,17.744705,8.4888831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 140.52197,279.78784 h -36.86681 q 2.04816,-15.21487 2.04816,-33.06308 v -65.83357 q -3.51112,0 -7.900028,0.58518 -4.388905,0.2926 -6.729654,0.58519 v -31.01493 h 14.629682 q 0,-31.30752 7.90003,-46.81498 10.82596,-21.35934 39.50014,-21.35934 11.70375,0 22.23712,3.803718 v 30.137142 q -4.97409,-2.63334 -9.363,-4.09631 -4.09631,-1.46297 -8.48521,-1.46297 -11.99634,0 -16.09265,10.53338 -2.63335,6.72965 -2.63335,20.77415 v 8.48521 h 31.01493 v 31.01493 Q 154.85906,180.306 140.22937,180.306 h -1.46297 q 0,8.19262 -0.29259,25.45565 -0.29259,17.26302 -0.29259,26.33343 0,16.09265 0.29259,25.74824 0.29259,9.65559 2.04816,21.94452 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontFamily: "'AR ESSENCE'",
      InkscapeFontSpecification: "'AR ESSENCE'",
      fill: "#ffffff",
      strokeWidth: 0.30524549
    },
    id: "path825"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.bad4b819a7c515d9855763a889063a1e.svg";
export { ForwardRef as ReactComponent };